export default "__VITE_ASSET__B7sAh3yL__"